module.exports = __webpack_public_path__ + "img/49.bf52b79e.jpg";